import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export function OtherSiteResolver({ tid, index, other, onDone }) {
  const [open, setOpen] = useState(false);
  const [sites, setSites] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [mode, setMode] = useState("new");
  const [siteId, setSiteId] = useState("");
  const [nf, setNf] = useState({ name: other?.name || "", address: other?.address || "", customer_id: "" });
  useEffect(() => {
    if (!open) return;
    api.get("/sites").then((r) => setSites(r.data)).catch(() => {});
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, [open]);
  const go = async () => {
    try {
      let sid = siteId;
      if (mode === "new") {
        if (!nf.name.trim() || !nf.customer_id) { toast.error("Enter a site name and pick a customer"); return; }
        const { data } = await api.post("/sites", { name: nf.name.trim(), address: nf.address, customer_id: nf.customer_id, status: "active" });
        sid = data.id;
      }
      if (!sid) { toast.error("Pick a site"); return; }
      const { data } = await api.post(`/timesheets/${tid}/assign-site`, { entry_index: index, site_id: sid });
      toast.success("Site set. You can now approve the timesheet"); setOpen(false); onDone(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <>
      <div className="mt-1 flex items-center gap-2 rounded bg-amber-50 border border-amber-200 px-2 py-1" data-testid={`other-site-flag-${index}`}>
        <span className="text-[11px] text-amber-800 flex-1">Other site: <b>{other?.name}</b>{other?.address ? ` · ${other.address}` : ""}</span>
        <Button size="sm" className="h-6 text-[11px] bg-amber-500 hover:bg-amber-600 text-black" data-testid={`other-site-resolve-${index}`} onClick={() => setOpen(true)}>Set up site</Button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="other-site-dialog">
          <DialogHeader><DialogTitle>Approve "Other site" time</DialogTitle><DialogDescription>Create the new site, or match it to an existing one. To refuse the time, return or reject the timesheet as normal.</DialogDescription></DialogHeader>
          <div className="flex gap-2">
            {[["new", "Create new site"], ["existing", "Use existing"]].map(([v, l]) => <Button key={v} size="sm" variant={mode === v ? "default" : "outline"} data-testid={`other-site-mode-${v}`} onClick={() => setMode(v)}>{l}</Button>)}
          </div>
          {mode === "new" ? (
            <div className="space-y-2">
              <div><Label>Site name</Label><Input data-testid="os-name" value={nf.name} onChange={(e) => setNf({ ...nf, name: e.target.value })} /></div>
              <div><Label>Address</Label><Input data-testid="os-address" value={nf.address} onChange={(e) => setNf({ ...nf, address: e.target.value })} /></div>
              <div><Label>Customer</Label>
                <Select value={nf.customer_id} onValueChange={(v) => setNf({ ...nf, customer_id: v })}>
                  <SelectTrigger data-testid="os-customer"><SelectValue placeholder="Select customer" /></SelectTrigger>
                  <SelectContent>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <p className="text-[11px] text-zinc-400">Set rates and the geo-fence later in Sites.</p>
            </div>
          ) : (
            <Select value={siteId} onValueChange={setSiteId}>
              <SelectTrigger data-testid="os-existing"><SelectValue placeholder="Select site" /></SelectTrigger>
              <SelectContent>{sites.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
            </Select>
          )}
          <Button data-testid="os-save" onClick={go} className="w-full bg-slate-900 text-white">Approve line & set site</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
